/* eslint-disable */
import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex)
const store = new vuex.Store({
  state: {
    bannerList: [],
    playFlag: true,
    bannerH: '4.5rem'
  },
  mutations: {
    changeBanner (state, newArr) {
      state.bannerList = newArr
      state.playFlag = newArr[0].title ? true : false
      let fontsize
      if (document.body.clientWidth < 960) {
        fontsize = document.body.clientWidth / 7.5
      } else {
        fontsize = 100
      }
      state.bannerH = newArr[0].title ? 4.5 * fontsize : 3.2 * fontsize
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/store.js